import { render, staticRenderFns } from "./SimilarPropertyItem.vue?vue&type=template&id=2f10205e&scoped=true"
import script from "./SimilarPropertyItem.vue?vue&type=script&lang=js"
export * from "./SimilarPropertyItem.vue?vue&type=script&lang=js"
import style0 from "./SimilarPropertyItem.vue?vue&type=style&index=0&id=2f10205e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f10205e",
  null
  
)

export default component.exports